export class AbstractService {
  constructor (client) {
    this.client = client;
  }
}
